import React, { useEffect } from 'react'
import { BsArrowRight } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import './ReConfirm.css'
const ReConfirm = () => {
  const navigate = useNavigate()
  useEffect(() => {
    setTimeout(() => {
      navigate('/signin-success')
    }, 4000)
  }, [navigate])
  return (
    <div className='container container_light reconfirm'>
      <div className='logo'>
        <img src='/assets/images/logo.png' alt='' />
        <h3>RROWHEAD</h3>
      </div>
      <div className='content'>
        <h1>Are You Sure?</h1>
        <p>
          <strong> 90%+ of our users</strong> say they have a{' '}
          <strong>10x better meeting experience</strong> on Arrowhead{' '}
          <strong>with the Chrome extension</strong>
        </p>

        <button
          onClick={() => {
            window.open(
              'https://chrome.google.com/webstore/detail/arrowhead/pdbahohfckjamlffhjfkbgmbhbkkiama'
            )
          }}
        >
          Download now from Chrome store
          <BsArrowRight size={14} style={{ marginLeft: '5px' }} />
        </button>
        <span>I still don’t want the optimal experience - download later</span>
      </div>
    </div>
  )
}

export default ReConfirm
